import { render } from "./AdminSeatLayout.vue?vue&type=template&id=881c226c&scoped=true"
import script from "./AdminSeatLayout.vue?vue&type=script&lang=js"
export * from "./AdminSeatLayout.vue?vue&type=script&lang=js"

import "./AdminSeatLayout.vue?vue&type=style&index=0&id=881c226c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881c226c"]])

export default __exports__